// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from 'wix-location';
import {setLectureType} from 'public/common.js';

$w.onReady(function () {	
});

export function navigateToLecturePage(category) {
	setLectureType(category);
	wixLocation.to('/request-a-lecture');
}

export function button1_click(event, $w) {
	navigateToLecturePage("Frontend");
}

export function button2_click(event, $w) {
	navigateToLecturePage("Backend");
}

export function button3_click(event, $w) {
	navigateToLecturePage("Culture");
}

export function button4_click(event, $w) {
	navigateToLecturePage("Mobile");
}